import '/assets/styles/main.css';
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import LazyLoad from 'vanilla-lazyload';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import anchor from '@alpinejs/anchor';

import exercise from './components/exercise.js';
import exerciseSubmission from './components/exerciseSubmission.js';
import copyText from './components/copyText.js';
import exerciseList from './components/exercise-list.js';
import carousels from './components/carousels.js';
import accordion from './components/accordion.js';
import mobileMenu from './components/mobile-menu.js';
import hideNavigation from './components/hide-navigation.js';
import favoriteBtn from './components/favorite-btn.js';
import addToCartBtn from './components/add-to-cart-btn.js';
import verifyEmail from './components/verify-email.js';
import planForm from './components/plan-form.js';
import selectionsPage from './components/selections-page.js';
import planPage from './components/plan-page.js';


window.lazyloadInstance = new LazyLoad();
window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.plugin(anchor);

Alpine.data('exercise', exercise);
Alpine.data('exerciseSubmission', exerciseSubmission);
Alpine.data('copyText', copyText);
Alpine.data('exerciseList', exerciseList);
Alpine.data('favoriteBtn', favoriteBtn);
Alpine.data('addToCartBtn', addToCartBtn);
Alpine.data('verifyEmail', verifyEmail);
Alpine.data('planForm', planForm);
Alpine.data('selectionsPage', selectionsPage);
Alpine.data('planPage', planPage);

Alpine.start();

document.addEventListener('DOMContentLoaded', () => {

  carousels();
  accordion();
  mobileMenu();
  hideNavigation();
});
